import PlaceRFIBtn from 'components/viewer/PlaceRFIBtn';
import CreatePunchBtn from 'pages/ViewerPage/Viewer/CreatePunchBtn';
import React, { FC } from 'react';

interface Props {
  sheetid?: string;
  pageid?: string;
}

const InteractionControls: FC<Props> = (props: Props) => {
  const { sheetid, pageid } = props;

  return (
    <div
      className="pos-a w100 row justify-center"
      style={{ bottom: '16px', left: '0px', pointerEvents: 'none' }}
    >
      <CreatePunchBtn />
      <div className="wrem-1" />
      <PlaceRFIBtn sheetid={sheetid || ''} pageid={pageid || ''} />
    </div>
  );
};

export default InteractionControls;
